import { AboutHero } from "@/components/About/about-hero";
import { Achievements } from "@/components/About/achievements";
import { StatsBar } from "@/components/About/stats-bar";
import { WhoWeAre } from "@/components/About/who-we-are";
import { HowWeWork } from "@/components/About/how-we-work";
import { Team } from "@/components/About/team";
import { AboutCta } from "@/components/About/about-cta";
import { SEO, seoConfig } from "@/components/SEO";

export function AboutPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SEO {...seoConfig.about} />
      <AboutHero />
      <StatsBar />
      <Achievements />
      <WhoWeAre />
      <HowWeWork />
      <Team />
      <AboutCta />
    </div>
  );
}
